export const MODULES = {
    DASHBOARD: 1,
    ROLES: 2,
    ROLEPERMISSION: 3,
    USERS: 4,
    USERPERMISSION: 5,
    BATCHES: 6,
    STUDENTS: 7,
    FINALLIST: 8,
    ATTENDANCE: 9,
    PAYMENTS: 10,
    NOTIFICATIONS: 11,
    REPORTS: 12,
    CONTACTENQUIRIES: 13,
    HOLIDAYS: 14,
};